export async function loadElementLocale(lang) {
    try {
      return await import(
        /* webpackChunkName: "element-locale-[request]" */
        `element-plus/dist/locale/${lang === 'zh-CN' ? 'zh-cn' : 'en'}.mjs`
      )
    } catch (error) {
      console.error('加载语言包失败，使用英文作为后备:', error)
      return await import('element-plus/dist/locale/en.mjs')
    }
  }